/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import type {DateInput} from 'common/widgets/date-range-picker/calendar-input/date-input/index';

export function template(this: DateInput) {
  const {dateObj} = this.state;

  return (
    <div sel='.date-input-container'>
      <input
        attrs={{
          type: `text`,
          placeholder: (dateObj && this.helpers.formatDate(dateObj)) || ``,
        }}
        class={{
          error: this.isAttributeEnabled(`error`),
        }}
        on={{
          focus: this.helpers.focusedInput,
          blur: this.helpers.blurredInput,
          change: this.helpers.changedInput,
        }}
      />
    </div>
  );
}
